import { render, staticRenderFns } from "./custom-select-new.vue?vue&type=template&id=16b1866f&scoped=true&"
import script from "./custom-select-new.vue?vue&type=script&lang=js&"
export * from "./custom-select-new.vue?vue&type=script&lang=js&"
import style0 from "./custom-select-new.vue?vue&type=style&index=0&id=16b1866f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b1866f",
  null
  
)

export default component.exports